module.exports = __webpack_public_path__ + "prize-1.69f96294.png";